import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface CommonState {
    lang: string;
}

const initialState: CommonState = {
    lang: 'ru'
} 

const commonSlice = createSlice({
    name: 'common',
    initialState,
    reducers: {
        setLanguage(state, action: PayloadAction<string>) {
            if (action.payload === 'kz' ||
                action.payload === 'en' ||
                action.payload === 'ru') {
                state.lang = action.payload;
            } else {
                state.lang = 'ru';
            }
        },
    }
})

export const { setLanguage } = commonSlice.actions
export default commonSlice.reducer;